import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useActionData, useFetcher } from 'react-router-dom';
import AddressBox from '../../components/data/address-box.jsx';
import { AddressSelector } from '../../components/project';
import { Modal } from '../../components/ui';
import styles from './project-item-address.module.scss';

const hasText = (value) => typeof value === 'string' ? value.trim().length > 0 : !!value

export const SingleDeliveryAddress = ({ customerAddresses, isConfirmed, selectedAddress, onChange }) => {
    const [address, setAddress] = useState(selectedAddress)
    const [addressPreview, setAddressPreview] = useState(false)
    const { t } = useTranslation()
    const fetcher = useFetcher()
    const { errors = {} } = useActionData() || {}
    const handleConfirm = (address) => {
        try {
            fetcher.submit({
                ...address,
                action: 'singleDeliveryAddress'
            }, {
                method: 'post',
                encType: 'application/json'
            })
        }
        catch (e) {
            return { error: e }
        }
    }

    useEffect(() => {
        if (typeof onChange !== 'function') {
            return
        }
        onChange([{ ...address }])
    }, [address, onChange])

    if (isConfirmed) {
        return (
            <div>
                <p>{t("Below is the Address confirmed by you")}</p>
                <div className={styles.addressSummary}>
                    <AddressBox address={customerAddresses.find(add => add.id === address?.address_id)} />
                    {hasText(address?.notes) && (
                        <p style={{ width: "100%", maxWidth: "550px", overflowWrap: "break-word" }}><strong>{t("Notes")}</strong> : {address?.notes}</p>
                    )}
                </div>
            </div>
        )
    }

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            <div className={`box--light-gray ${styles.addressBox}`}>
                <AddressSelector
                    name="address_id"
                    addresses={customerAddresses}
                    selectedAddressId={address?.address_id}
                    onChange={(id) => { setAddress({ ...address, address_id: id }) }}
                    excludedAddresses={address ? [address.id] : []}
                />
                {!!errors.address_id && errors.address_id.map(error => <p key={error} className='error'>{error}</p>)}
                <label>{t("Notes")}</label>
                <textarea name="notes" rows={4} style={{ width: "100%" }} defaultValue={address?.notes}
                    onChange={(e) => setAddress({ ...address, notes: e.target.value })}
                />
            </div>
            <div className="actions align--right">
                <button className="button--primary" onClick={() => { setAddressPreview(true) }}>{t('Save')}</button>
            </div>
            <Modal title={t("Selected Address")} isVisible={addressPreview} onClose={() => {
                setAddressPreview(false)
            }}>
                <div className={fetcher.state !== 'idle' ? 'loading' : ''}>
                    <p>{t("Please confirm your selection of this address as it will be final and cannot be changed later.")}</p>
                    <div className={styles.addressSummary}>
                        <div>
                            <AddressBox address={customerAddresses.find(add => add.id === address?.address_id)} />
                        </div>
                        <div style={{ textAlign: "left" }}>
                            <p><strong>{t("Quantity")}</strong> : {address?.quantity}</p>
                            {hasText(address?.notes) && <p><strong>{t("Notes")} </strong>: {address?.notes}</p>}
                        </div>
                    </div>
                    <div className="actions" style={{ marginTop: 30 }}>
                        <button className="button--primary" onClick={() => { handleConfirm(address) }} disabled={fetcher.state !== 'idle'}>{t("Save")}</button>
                        <button className="button--cancel" onClick={() => setAddressPreview(false)} disabled={fetcher.state !== 'idle'}>{t("Cancel")}</button>
                    </div>
                </div>
            </Modal>
        </div>
    )
}
SingleDeliveryAddress.propTypes = {
    customerAddresses: PropTypes.arrayOf(PropTypes.object).isRequired,
    onChange: PropTypes.func.isRequired,
    isConfirmed: PropTypes.bool,
    selectedAddress: PropTypes.object,
}

export default SingleDeliveryAddress
